import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { useUser } from '../contexts/UserContext';

/**
 * Custom hook to handle post-login redirects
 * 
 * This hook checks if there's a stored redirect path in sessionStorage
 * and redirects the user to that path after successful authentication
 */
const usePostLoginRedirect = () => {
  const navigate = useNavigate();
  const { accounts } = useMsal();
  const { user, loading: userLoading } = useUser();

  useEffect(() => {
    const handlePostLoginRedirect = () => {
      if (!userLoading && accounts.length > 0 && user?.accessRights) {
        const redirectPath = sessionStorage.getItem('redirectAfterLogin');

        if (redirectPath) {
          console.log('PostLoginRedirect: Redirecting to stored path:', redirectPath);
          sessionStorage.removeItem('redirectAfterLogin');
          navigate(redirectPath, { replace: true });
        }
      }
    };

    handlePostLoginRedirect();
  }, [accounts, user, userLoading, navigate]);
};

export default usePostLoginRedirect;